export class MasterSettings {
  credentials: { mailConfig: Record<string, any> }

  constructor(jsonData: Record<string, any> = {}) {
    this.credentials = jsonData.credentials || { mailConfig: {} }
  }
}
